import { type FC, useEffect, useRef } from 'react';
import HeightChart from 'src/components/Player/InfoSheet/HeightChart';
import { useWindowSize } from 'usehooks-ts';
import ControlBar from '../components/Player/ControlBar';
import { HashManager } from '../lib/player/controller/HashManager';
import { KeyPressManager } from '../lib/player/controller/KeyPressManager';
import { GroupLiveMotionManager } from '../lib/player/controller/LiveMotionManager';
import { GroupStarterTrackManager } from '../lib/player/controller/StarterTrackManager';
import { Timer } from '../lib/player/controller/Timer';
import { triggerLeaderboardLoad } from '../lib/player/model';
import { getCurrentEvents, reduceStartTime } from '../lib/player/selectors';
import { useStore } from '../lib/player/store';

export const ElevationChartView: FC = () => {
  const isPlaying = useStore((state) => state.timer.isPlaying);
  const currentEventIndices = useStore((state) => state.currentEventIndices);
  const currentEvents = useStore((state) => getCurrentEvents(state));
  const startTime = reduceStartTime(currentEvents);
  const eventId = useStore((state) => state.eventId);
  const { width, height } = useWindowSize();

  const pageviewTrackerRef = useRef<Set<string> | null>(null);

  useEffect(() => {
    let pageViewTracker = pageviewTrackerRef.current;
    if (pageViewTracker == null) {
      pageviewTrackerRef.current = new Set();
      pageViewTracker = pageviewTrackerRef.current;
    }
    if (!pageViewTracker.has(eventId)) {
      triggerLeaderboardLoad(eventId);
      pageViewTracker.add(eventId);
    }
  }, [eventId]);

  if (currentEventIndices.length === 0) return null;

  return (
    <div className="elevation-chart-view">
      {isPlaying && <Timer interval={50} />}
      {startTime <= Date.now() && <KeyPressManager />}
      <GroupLiveMotionManager />
      <GroupStarterTrackManager />
      <HashManager />
      <HeightChart width={Math.floor(width)} height={Math.floor(height) - 75} />
      <ControlBar className="control-bar" />
    </div>
  );
};
